import {
  transformTrustpilotStoreReviewsToDisplay,
  type TrustpilotDisplayData,
} from "@made-people/grease-trustpilot";
import {
  bffFetchTrustpilotStoreSummary,
  bffFetchTrustpilotStoreReviews,
} from "@made-people/grease-bff";
import type { BffClient } from "@made-people/gears-bff-client";
import { cacheKey } from "../../utils/create-cache-keygen";
import { createPromiseDedupe } from "../../utils/create-promise-dedupe";

interface FetchStoreReviewsOptions {
  language?: string;
  perPage?: number;
  page?: number;
  stars?: number[];
}

const cache = new Map<string, TrustpilotDisplayData | null>();
const dedupe = createPromiseDedupe<TrustpilotDisplayData | null>();

export async function fetchTrustpilotStoreReviews(
  bffClient: BffClient,
  options: FetchStoreReviewsOptions,
): Promise<TrustpilotDisplayData | null> {
  try {
    const key = cacheKey(options);
    const cachedData = cache.get(key);
    if (cachedData) {
      return cachedData;
    }

    return dedupe(key, async () => {
      const [storeReviewsResponse, storeSummary] = await Promise.all([
        bffFetchTrustpilotStoreReviews(bffClient, {
          perPage: options.perPage ?? 12,
          page: options.page ?? 1,
          language: options.language,
          stars: options.stars,
        }),
        bffFetchTrustpilotStoreSummary(bffClient),
      ]);

      if (
        storeReviewsResponse?.reviews &&
        storeReviewsResponse.reviews.length > 0
      ) {
        const data = transformTrustpilotStoreReviewsToDisplay(
          storeReviewsResponse,
          storeSummary,
        );
        cache.set(key, data);
        return data;
      }

      return null;
    });
  } catch (error) {
    console.error("[fetchTrustpilotStoreReviews] Error:", error);
    return null;
  }
}
